import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { map, tap } from "rxjs/operators";
import { DealershipsQueryParams } from "./dealerships.service";

@Injectable()
export class MarcaService {
  private modelCache = {};
  private singleModelCache = {};
  private marcaCache = {};

  constructor(private http: HttpClientService) {}

  public getMarcasModelos(): Observable<any> {
    return this.http
      .get("/api/marcas/marcas_modelos")
      .pipe(tap((_) => console.log("MarcasService.getMarcasModelos: Ok.")));
  }
  public getAll(application_id?: number, person_id?: number, forceRefresh = false): Observable<any[]> {
    const key = `all_${application_id || "none"}_${person_id || "none"}`;
    if (forceRefresh || !this.marcaCache[key]) {
      this.marcaCache[key] = this.requestAll(application_id, person_id).pipe(shareReplay(1));
    }
    return this.marcaCache[key];
  }

  private requestAll(application_id?: number, person_id?: number): Observable<any[]> {
    const params: { [key: string]: string } = {};
    if (application_id) params.application_id = application_id.toString();
    if (person_id) params.person_id = person_id.toString();

    return this.http.get("/api/marcas", { params }).pipe(tap((_) => console.log("MarcasService.getAll: Ok.")));
  }

  public getMarca(id): Observable<any> {
    if (!this.marcaCache[id]) {
      this.marcaCache[id] = this.requestMarca(id).pipe(shareReplay(1));
    }
    return this.marcaCache[id];
  }

  private requestMarca(id): Observable<any[]> {
    return this.http.get(`/api/marcas/${  id}`).pipe(tap((_) => console.log("MarcasService.getMarca: Ok.")));
  }

  public getModels(id): Observable<any[]> {
    if (!this.modelCache[id]) {
      this.modelCache[id] = this.requestModels(id).pipe(shareReplay(1));
    }
    return this.modelCache[id];
  }

  public requestModels(id, year?): Observable<any[]> {
    const options = { params: { year } };
    return this.http
      .get(`/api/marcas/${  id  }/modelos`)
      .pipe(tap((_) => console.log("MarcasService.getModels: Ok.")));
  }

  public getModel(id): Observable<any[]> {
    if (!this.singleModelCache[id]) {
      this.singleModelCache[id] = this.requestModel(id).pipe(shareReplay(1));
    }
    return this.singleModelCache[id];
  }

  public requestModel(id): Observable<any> {
    return this.http.get(`/api/modelos/${  id}`).pipe(tap((_) => console.log("MarcasService.getModel: Ok.")));
  }

  public getVersions(id: number, year?, new_asset?, by_year = false): Observable<any> {
    const options = { params: { year, new_asset, by_year: by_year.toString() } };
    return this.http
      .get(`/api/modelos/${  id  }/versiones`, options)
      .pipe(tap((_) => console.log("MarcasService.getVersiones: Ok.")));
  }

  public addDealership(data): Observable<any> {
    if (data.marca_id == 0) {
      data.marca_id = null;
    }
    return this.http.post("/api/dealerships", data).pipe(tap((_) => console.log("MarcasService.addDealership: Ok.")));
  }

  public updateDealership(data, options: { includeInactive?: boolean } = {}): Observable<any> {
    const httpOptions: { params?: DealershipsQueryParams } = {};
    if (options.includeInactive) {
      httpOptions.params = {
        active: "all",
      };
    }
    return this.http
      .put(`/api/dealerships/${  data.id}`, data, httpOptions)
      .pipe(tap((_) => console.log("MarcasService.updateDealership: Ok.")));
  }

  public createMarca(data): Observable<any> {
    return this.http.post("/api/marcas", data).pipe(tap((_) => console.log("MarcaService.createMarca: Ok.")));
  }

  public createModelo(data): Observable<any> {
    return this.http
      .post(`/api/marcas/${  data.marca_id  }/modelos`, data)
      .pipe(tap((_) => console.log("MarcaService.createModelo: Ok.")));
  }
}
